import { render } from "./RouteNotAuthorisedComponent.vue?vue&type=template&id=13ed6417&ts=true"
import script from "./RouteNotAuthorisedComponent.vue?vue&type=script&lang=ts"
export * from "./RouteNotAuthorisedComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__